import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "card-info" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-action" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "btn-main" }, "Заказать", -1)
const _hoisted_9 = { class: "price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllSections, (section, sectionId) => {
      return (_openBlock(), _createElementBlock("div", { key: sectionId }, [
        _createElementVNode("h2", {
          class: "",
          id: section.url
        }, _toDisplayString(section.name), 9, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMealsBySectionId(sectionId), (meal, mealId) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card",
              key: mealId,
              onClick: ($event: any) => (_ctx.openMealCard(mealId))
            }, [
              _createElementVNode("img", {
                src: meal.menuImgUrl,
                alt: meal.name.toLowerCase()
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(meal.name), 1),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(meal.price), 1)
                ])
              ])
            ], 8, _hoisted_3))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}